import { defineStore } from 'pinia'
import axios from 'axios'

// APIのベースURLを環境変数から取得（なければ空文字列で相対パス）
const API_BASE_URL = process.env.VUE_APP_API_URL || ''

export const useWeatherStore = defineStore('weather', {
  state: () => ({
    areas: [],
    userAreas: [],
    dashboardData: null,
    currentWeatherData: null,
    isLoading: false
  }),

  actions: {
    async fetchAreas() {
      this.isLoading = true
      try {
        const response = await axios.get(`${API_BASE_URL}/api/weather/areas/`)
        this.areas = response.data.results || response.data
        return response.data.results || response.data
      } catch (error) {
        console.error('fetchAreas error:', error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async fetchUserAreas() {
      this.isLoading = true
      try {
        const response = await axios.get(`${API_BASE_URL}/api/auth/areas/`)
        this.userAreas = response.data.results || response.data
        return response.data.results || response.data
      } catch (error) {
        console.error('fetchUserAreas error:', error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async addUserArea(areaData) {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/auth/areas/`, areaData)
        return response.data
      } catch (error) {
        throw error
      }
    },

    async removeUserArea(areaId) {
      try {
        await axios.delete(`${API_BASE_URL}/api/auth/areas/${areaId}/`)
        this.userAreas = this.userAreas.filter(area => area.id !== areaId)
      } catch (error) {
        throw error
      }
    },

    async fetchDashboard() {
      this.isLoading = true
      try {
        const response = await axios.get(`${API_BASE_URL}/api/weather/dashboard/`)
        this.dashboardData = response.data
        return response.data
      } catch (error) {
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async fetchWeatherForecast(areaId) {
      this.isLoading = true
      try {
        const response = await axios.get(`${API_BASE_URL}/api/weather/forecast/${areaId}/`)
        this.currentWeatherData = response.data
        return response.data
      } catch (error) {
        throw error
      } finally {
        this.isLoading = false
      }
    }
  }
})